/**
 * @generated SignedSource<<d2b0d0442b1824e8409e7c56b99ee5e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteEditSharedInfo_widgetNote$data = {
  readonly widgets: ReadonlyArray<{
    readonly storecast: {
      readonly id: string;
      readonly name: string;
    } | null;
  }>;
  readonly " $fragmentType": "NoteEditSharedInfo_widgetNote";
};
export type NoteEditSharedInfo_widgetNote$key = {
  readonly " $data"?: NoteEditSharedInfo_widgetNote$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteEditSharedInfo_widgetNote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteEditSharedInfo_widgetNote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNote",
      "kind": "LinkedField",
      "name": "widgets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "storecast",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "70b3fa73ea61ab52e69fe22575315bd8";

export default node;
